import { Navigate } from 'react-router';
import { useAuth } from '../context/authContext';
import { useEffect } from 'react';

export const CanAuth = ({ children }) => {
    const { authUser, loading } = useAuth();


    if(loading) {
        return null;
    }

    if(!authUser) {
        return <Navigate to="/login" />;
    }

    return children;
}